'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var YelpAppIcon = function YelpAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    version: "1.1",
    id: "logos",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    fill: "#FB2212",
    d: "M63.333,140.667l58,28.333c11,5.666,9.333,21.666-2.667,25l-63,15.666C48,212,40,206.334,39,198\n\t\tc-2.333-17.334,0-34,5-49.667C47.333,140.667,56,137,63.333,140.667z"
  }), React__default["default"].createElement("path", {
    fill: "#FB2212",
    d: "M86.667,260.334l43.333-48c8.333-9.334,24-2.668,23.334,9.332l-2,65c-0.668,7.668-7.667,14-15.667,12.668\n\t\tc-16.667-2.668-32.333-9.334-46.333-19C82.333,275.666,81.333,266,86.667,260.334z"
  }), React__default["default"].createElement("path", {
    fill: "#FB2212",
    d: "M189.334,196.334l61.666,20c7.666,2.332,11,11,7.666,18.332C251.334,249.666,241,263,228,274.334\n\t\tc-6,5-15.666,4-20-3.334l-34.334-55C167.666,205.334,177.666,192.666,189.334,196.334z"
  }), React__default["default"].createElement("path", {
    fill: "#FB2212",
    d: "M252,157l-62.334,17.666c-11.666,3.334-21.666-10-14.332-20l36.332-53.333c4.334-6.667,14-7.667,20-2.667\n\t\tc12.334,11,22.668,24.333,29.668,40.667C264,146.333,260,154.666,252,157z"
  }), React__default["default"].createElement("path", {
    fill: "#FB2212",
    d: "M106.667,6C95.667,8.667,85,13.333,75,17.667C67.667,21,65.667,30,69.333,36.667L130,142\n\t\tc6.667,11.666,25,7.333,25-6.667V13.667c0-7.667-6.667-14-14.333-13.333C129,1,118,3.333,106.667,6z"
  })));
};

var YelpAppIcon$1 = iconStyles()(YelpAppIcon);

module.exports = YelpAppIcon$1;
